import React from 'react';
import { Route, Switch } from 'react-router';
import HashtagOverview from './HashtagOverview';
import HashtagInsights from './HashtagInsights';
import HashtagDrilldown from './HashtagDrilldown';
import './UserChats.css';

// bug903 follow-up: hidden per product decision (inconsistent with the
// Survey/KC/Message list pages, which have no such tab). Flip to restore.
const SHOW_TOP_LEVEL_INSIGHTS_TAB = false;

const UC_TABS = [
    { key: 'overview', label: 'User Chats', path: '' },
    { key: 'insights', label: 'Insights', path: '/insights' },
];

// bug903: shell tab bar for the two top-level User Chats routes only — the
// drilldown route renders standalone below, keeping its own breadcrumb.
const UserChatsTabBar = ({ activeKey, baseUrl, history }) => (
    <div className="uc-tabs-style">
        {UC_TABS.map((tab) => (
            <span
                key={tab.key}
                className={`uc-tab-item ${activeKey === tab.key ? 'active' : ''}`}
                onClick={() => {
                    if (tab.key === activeKey) return;
                    history.push(`${baseUrl}${tab.path}`);
                }}
            >
                {tab.label}
            </span>
        ))}
    </div>
);

const UserChatsPage = (props) => {
    const { match, history } = props;
    const baseUrl = `${match.path}/user-chats`;

    return (
        <div className="user-chats-container">
            <Switch>
                {/* Must be matched before the dynamic drilldown route below,
                    or "/insights" would be swallowed as a :hashtag segment. */}
                {SHOW_TOP_LEVEL_INSIGHTS_TAB && (
                    <Route exact path={`${baseUrl}/insights`} render={(routeProps) => (
                        <React.Fragment>
                            <UserChatsTabBar activeKey="insights" baseUrl={baseUrl} history={history} />
                            <HashtagInsights {...props} {...routeProps} />
                        </React.Fragment>
                    )} />
                )}
                <Route exact path={baseUrl} render={(routeProps) => (
                    SHOW_TOP_LEVEL_INSIGHTS_TAB ? (
                        <React.Fragment>
                            <UserChatsTabBar activeKey="overview" baseUrl={baseUrl} history={history} />
                            <HashtagOverview {...props} {...routeProps} />
                        </React.Fragment>
                    ) : (
                        <HashtagOverview {...props} {...routeProps} />
                    )
                )} />
                <Route exact path={`${baseUrl}/:hashtag/:groupId`} render={(routeProps) => <HashtagDrilldown {...props} {...routeProps} />} />
            </Switch>
        </div>
    );
};

export default UserChatsPage;
